import { Component, Input, OnInit } from '@angular/core';
import { IExternalBooking, IExternalBookingHost } from "../../service/resources/booking/interfaces/IGetBookings";
import { Yii } from "libraries/interfaces/Yii";
import { EInterfaceValues } from "libraries/component/interface-flag/interface-flag.component";

interface ILine {
    ref: string;
    code: string;
    host: string;
    status: string;
    interface: EInterfaceValues;
}

export enum EExternalBookingDisplayMode {
    searchResult = "searchResult",
    booking = "booking",
}

@Component({
    selector: 'external-booking',
    template: `
        <ng-container *ngIf="formatedExternalBookings?.length">
            <ng-container *ngIf="displayMode === displayModes.searchResult">
                <div class="external-booking-in-result" *ngFor="let line of formatedExternalBookings">
                    {{line.ref}}
                    {{line.code}}
                    {{ line.host | hostAlias | async }}
                    <interface-flag *ngIf="line.interface" [interface]="line.interface"></interface-flag>
                    {{line.status}}
                </div>
            </ng-container>
            <ng-container *ngIf="displayMode === displayModes.booking">
                <div class="external-booking-in-booking" *ngFor="let line of formatedExternalBookings">
                    <div class="ref">{{line.ref}}</div>
                    <div>
                        <strong>
                            {{line.code}}
                            {{ line.host | hostAlias | async }}
                        </strong>
                        <interface-flag [interface]="line.interface"></interface-flag>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    `,
    styles: [`
        .external-booking-in-booking{
            display: flex;
        }
        .external-booking-in-booking .ref{
            width: 120px;
        }
        interface-flag{
            /*margin-left : .375rem*/
        }
    `]
})
export class ExternalBookingComponent implements OnInit {
    @Input()
    public externalBookings?: IExternalBooking[];
    @Input()
    public displayMode: EExternalBookingDisplayMode = EExternalBookingDisplayMode.searchResult;

    public displayModes: typeof EExternalBookingDisplayMode = EExternalBookingDisplayMode;

    public formatedExternalBookings: ILine[];

    private transcodedOrigin: { [key: string]: string } = {
        gds: "GDS",
        agency: Yii.t("wui-shared-js", "Agence"),
        vendor: Yii.t("wui-shared-js", "Fournisseur"),
    };

    public ngOnInit(): void {
        if (this.externalBookings) {
            this.formatedExternalBookings = this.externalBookings
                .filter(
                    (externalBooking: IExternalBooking): boolean => Boolean(externalBooking.host) && Boolean(externalBooking.code)
                )
                .map(
                    (externalBooking: IExternalBooking): ILine => {
                        const ref: string = Yii.t("wui-sasha-js", "Réf. ");
                        const origin: string = externalBooking.xOrigin ?? externalBooking.origin;
                        const originValue: string = this.transcodedOrigin[origin.toLowerCase()] ?? origin;
                        const code: string = externalBooking.code;
                        const hostCode: string = typeof externalBooking.host === "string"
                            ? externalBooking.host
                            : Boolean(externalBooking.host)
                                ? (externalBooking.host as IExternalBookingHost).code
                                : null;
                        const status: string = externalBooking.status
                            ? ` - ${externalBooking.status}`
                            : null;
                        const xStatus: string = externalBooking.xStatus
                            ? ` - ${externalBooking.xStatus}`
                            : null;
                        const interfaceValue: EInterfaceValues = (externalBooking.host as IExternalBookingHost)?.interface?.name;
                        return {
                            ref: `${ref}${originValue ?? ''} :`,
                            code,
                            host: hostCode,
                            status: xStatus ?? status,
                            interface: interfaceValue,
                        };
                    }
                );
        }
    }
}
